// extracted by mini-css-extract-plugin
export default {"label":"aNpMa","sidePlace":"bNpMa","inputPlace":"cNpMa"};